import { useRef } from 'react'

/**
 * React hook to create a constant value that is only initialized once.
 *
 * @param init - Function to initialize constant value
 */
export function useConstant<T>(init: () => T): T {
  const ref = useRef<T>(null)

  if (ref.current == null) {
    ref.current = init()
  }

  return ref.current
}
